import React from 'react';
import { useEffect } from 'react';

import bannerMobile from './media/bannerServiziMobile.jpeg';
import bannerDesktop from './media/bannerServiziDesktop.jpg';

function Servizi() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <div>
      <section className="h-full text-white bg-gray-900">
        <div className="container px-10 py-16 mx-auto sm:px-10 lg:px-10">
          <div className="gap-10 max-h-min lg:flex">
            <div className="">
              <div className="flex flex-col items-start justify-start gap-4">
                <span className="font-medium tracking-widest text-blue-400">
                  CONSULTING
                </span>
                <h1 className="text-3xl">
                  ENGINEERING SERVICES IN THE FIELD OF SUSTAINABLE MOBILITY
                </h1>
                <p>
                  From the beginning, eDriveLAB has been performing Engineering
                  Services in the field of sustainable mobility and
                  technological innovation.
                  <br />
                  <br />
                  We follow the client from the idea on the sheet of paper,
                  through a process of design and analysis, to the prototyping
                  of the vehicle.
                </p>
                <img src="" alt="" />
              </div>
              <img
                src={bannerMobile}
                alt="bannerMobile"
                className="lg:hidden"
              />
              <div className="flex flex-col items-start justify-start gap-4 pt-4">
                <span className="font-medium tracking-widest text-blue-400">
                  DESIGN
                </span>
                <h1 className="text-3xl">MODEL-BASED DEVELOPMENT</h1>
                <div className="pl-4 border-l-4 border-l-blue-500">
                  <span className="text-xl font-bold ">Vehicle Simulation</span>
                  <p>
                    Design tools based on vehicle, powertrain, and strategy
                    modeling with a particular focus on the components that make
                    up an electrified system. Automatically generated vehicle
                    sosftware via Model Design Development
                    <br />
                    <br />
                    Vehicle modeling is done through the study of:
                  </p>
                  <ul className="list-disc list-inside">
                    <li>Balancing of the forces involved</li>
                    <li>Longitudinal/vertical model </li>
                    <li>3D Model</li>
                  </ul>
                  <p>
                    Development of efficient models to simulate the entire
                    driving cycle.
                  </p>
                </div>
                <div className="pl-4 mt-4 border-l-4 border-l-blue-500">
                  <span className="text-xl font-bold">
                    EV Powertrain Layout
                  </span>
                  <p>
                    Advanced powertrain simulations to define vehicle
                    specifications
                    <br />
                    <br />
                    Electrical, thermal, mechanical modeling of each vehicle
                    component
                  </p>
                </div>
              </div>
            </div>
            <div className="max-h-min">
              <img
                src={bannerDesktop}
                alt=""
                className="hidden overflow-hidden lg:block"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Servizi;
